import { ReadReservationsState, ReservationsActionTypes, READ_RESERVATIONS_DATA_REQUEST, READ_RESERVATIONS_DATA_SUCCESS, READ_RESERVATIONS_DATA_FAILURE } from "store/reducers/room/readReservationsData/types";

const defaultState: ReadReservationsState = {
  isLoading: false,
  errorMessage: ""
};

export default function reservations(state = defaultState, action: ReservationsActionTypes): ReadReservationsState {
  switch (action.type) {
    case READ_RESERVATIONS_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_RESERVATIONS_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_RESERVATIONS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};